/* @sravni/react-design-system version 0.2.60 */
import { createContext } from 'react';

var SheetContext = createContext({});

export default SheetContext;
//# sourceMappingURL=SheetContext.js.map
